import CompanyFieldDefinitionsAPI from '../../api/companyFieldDefinitions';

export const state = {
  records: [],
  uiFlags: { isFetching: false, isSaving: false },
};

export const getters = {
  getAll: _state => _state.records,
  getEnabled: _state => _state.records.filter(f => f.enabled),
  uiFlags: _state => _state.uiFlags,
};

export const mutations = {
  SET_UI_FLAG(_state, data) { _state.uiFlags = { ..._state.uiFlags, ...data }; },
  SET_RECORDS(_state, data) { _state.records = data; },
  ADD_RECORD(_state, data) { _state.records = [..._state.records, data]; },
  EDIT_RECORD(_state, data) {
    _state.records = _state.records.map(r => (r.id === data.id ? data : r));
  },
  DELETE_RECORD(_state, id) { _state.records = _state.records.filter(r => r.id !== id); },
  REORDER_RECORDS(_state, ids) {
    const map = Object.fromEntries(_state.records.map(r => [r.id, r]));
    _state.records = ids.map((id, idx) => map[id] ? { ...map[id], position: idx } : null).filter(Boolean);
  },
};

export const actions = {
  fetchAll: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CompanyFieldDefinitionsAPI.getAll();
      commit('SET_RECORDS', data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, payload) => {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const { data } = await CompanyFieldDefinitionsAPI.create({ field: payload });
      commit('ADD_RECORD', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  update: async ({ commit }, { id, ...payload }) => {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const { data } = await CompanyFieldDefinitionsAPI.update(id, { field: payload });
      commit('EDIT_RECORD', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  delete: async ({ commit }, id) => {
    await CompanyFieldDefinitionsAPI.delete(id);
    commit('DELETE_RECORD', id);
  },

  reorder: async ({ commit, dispatch }, ids) => {
    commit('REORDER_RECORDS', ids);
    try {
      await CompanyFieldDefinitionsAPI.reorder(ids);
    } catch {
      dispatch('fetchAll');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
